export type Block = "kid" | "community" | "purchasing" | "managingProfiles";

// Default behavior is "allow" — routes not listed here render normally.
export const accessRestrictions: Array<{
  matches: (path: string) => boolean;
  block: Block;
}> = [
  {
    matches: (p) =>
      p.startsWith("/campaigns") ||
      p.startsWith("/communities") ||
      p.startsWith("/community") ||
      p.startsWith("/trivia") ||
      p.startsWith("/admin"),
    block: "community",
  },
  {
    matches: (p) => p.startsWith("/gift") || p.startsWith("/giftmobile"),
    block: "purchasing",
  },
  {
    matches: (p) => /^\/gift\/[^/]+$/.test(p) || p.startsWith("/redeemmobile/"),
    block: "kid",
  },
  {
    matches: (p) =>
      p === "/subscribe" ||
      p === "/redeem" ||
      p === "/account-merge" ||
      p.startsWith("/settings/account/merge"),
    block: "kid",
  },
  {
    matches: (p) => p.startsWith("/settings/kids"),
    block: "kid",
  },
  {
    matches: (p) => p.startsWith("/settings/kids-profiles/add"),
    block: "managingProfiles",
  },
  {
    matches: (p) => p.startsWith("/settings/family"),
    block: "managingProfiles",
  },
];

export const resolveBlocksFor = (pathname: string): Block[] =>
  accessRestrictions
    .filter((restriction) => restriction.matches(pathname))
    .map((restriction) => restriction.block);
